import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useState } from 'react'
import { z } from 'zod'
import { profileQueries } from '@/api/endpoints/profiles'
import { Button } from '@/components/ui/button'
import { BulkLinkForm } from '@/features/accounts/bulk-link-form'
import { SingleLinkForm } from '@/features/accounts/single-link-form'
import { useLinkForm } from '@/features/accounts/use-link-form'

export const Route = createFileRoute('/_authed/accounts/link')({
  validateSearch: z.object({ profile: z.string().uuid().optional().catch(undefined) }),
  component: LinkAccountsPage,
})

function LinkAccountsPage() {
  const { profile } = Route.useSearch()
  const [bulk, setBulk] = useState(false)
  const form = useLinkForm(profile ?? '')
  const { data: preset } = useQuery({ ...profileQueries.detail(profile ?? ''), enabled: !!profile })
  const selectedProfile =
    profile && preset?.name ? { value: profile, label: preset.name } : undefined

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <div className="flex flex-wrap items-center gap-3">
        <Button variant="ghost" size="sm" asChild>
          <Link to="/accounts">
            <ArrowLeft />
            Accounts
          </Link>
        </Button>
        <h1 className="text-2xl font-semibold">Link accounts</h1>
      </div>
      <div className="flex gap-2" role="group" aria-label="Link mode">
        <Button
          variant={bulk ? 'outline' : 'default'}
          aria-pressed={!bulk}
          onClick={() => setBulk(false)}
        >
          One account
        </Button>
        <Button
          variant={bulk ? 'default' : 'outline'}
          aria-pressed={bulk}
          onClick={() => setBulk(true)}
        >
          Several accounts
        </Button>
      </div>
      {bulk ? (
        <BulkLinkForm form={form} selectedProfile={selectedProfile} />
      ) : (
        <SingleLinkForm form={form} selectedProfile={selectedProfile} />
      )}
    </div>
  )
}
